import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import DonationModal from "../components/common/DonationModal"; 
import logo from "../assets/sevaa.png";
import AuthModal from "../components/common/AuthModal";

const Navbar = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [user, setUser] = useState<{name: string, email: string} | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false); 
  
  // Naya State Contact Info ke liye
  const [contactInfo, setContactInfo] = useState({ phone: "+91-99102 18596", email: "info@sevaafoundation.com" });

  const location = useLocation();

  useEffect(() => {
    const handleOpen = () => setIsModalOpen(true);
    window.addEventListener('openDonationModal', handleOpen);
    
    const loggedInUser = localStorage.getItem('sevaa_user');
    if(loggedInUser) setUser(JSON.parse(loggedInUser));

    // Backend se contact info fetch karna
    fetch("https://www.sevaafoundation.com/seva-backend/api/settings/get_contact_info.php")
      .then(res => res.json())
      .then(data => { if(data.success) setContactInfo(data.data); })
      .catch(err => console.error(err));

    return () => window.removeEventListener('openDonationModal', handleOpen);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('sevaa_user');
    setUser(null);
    setIsUserMenuOpen(false);
  };

  const dropdownContent: { [key: string]: { name: string; path: string }[] } = {
    "Who We Are": [
      { name: "About Us", path: "/about" },
      { name: "Objectives", path: "/objectives" },
      { name: "LeaderShip", path: "/our-team" },
      { name: "Our Transparency", path: "/legal-documents" },
    ],
    "What We Do": [
      { name: "Child Education", path: "/child-education" },
      { name: "Tree Plantation", path: "/tree-plantation" },
      { name: "Hunger Support", path: "/hunger-support" },
      { name: "Women Empowerment", path: "/women-empowerment" },
      { name: "Homes for Old Age People", path: "/old-age-homes" },
      { name: "Medical And Blood Donation", path: "/medical-blood-donation" },
    ],
    "Blogs & Stories": [
      { name: "Video Gallery", path: "/video-gallery" },
      { name: "Photo Gallery", path: "/photo-gallery" },
      { name: "Blogs", path: "/blogs" },
    ],
    "Get Involved": [
      { name: "CSR Opportunities", path: "/csr" },
      { name: "Become Volunteer", path: "/volunteer" },
    ],
  };

  return (
    <header className="w-full bg-white shadow-sm z-50 sticky top-0 font-poppins">
      <div className="w-full h-[24px] bg-gradient-to-r from-[#FF671F] via-[#FFD1A3] to-[#046A38] overflow-hidden flex items-center relative border-b border-gray-100">
        <motion.div animate={{ x: [1500, -1500] }} transition={{ duration: 50, repeat: Infinity, ease: "linear" }} className="whitespace-nowrap flex gap-20 items-center text-gray-900 text-[9px] uppercase tracking-widest px-4">
          <span className="flex items-center gap-2 font-bold"><span className="text-orange-600">★</span> Emergency Relief: Support the Healthcare Drive 2026</span>
          <span className="flex items-center gap-2 font-bold"><span className="text-emerald-700">★</span> Education for all: 5000+ children waiting for school kits</span>
          <span className="flex items-center gap-2 font-bold"><span className="text-orange-600">★</span> New Campaign: "She Can Fly" initiative launched in 10 cities</span>
          <span className="flex items-center gap-2 font-bold"><span className="text-emerald-700">★</span> Join as a Volunteer: Registration open for Ground Operations</span>
        </motion.div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1 hidden lg:flex justify-between items-center">
        <Link to="/" className="flex items-center"><img src={logo} alt="Sevaa Foundation Logo" className="h-20 lg:h-24 w-auto object-contain py-1" /></Link>
        <div className="flex gap-8 items-center">
          <div className="flex gap-8 items-center">
            <div className="flex flex-col">
              <span className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">Helpline</span>
              <a href={`tel:${contactInfo.phone.replace(/[^0-9+]/g, '')}`} className="text-sm font-black text-gray-900">{contactInfo.phone}</a>
            </div>
            <div className="w-px h-8 bg-gray-200"></div>
            <div className="flex flex-col">
              <span className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">Send Email</span>
              <a href={`mailto:${contactInfo.email}`} className="text-sm font-black text-gray-900 tracking-tight">{contactInfo.email}</a>
            </div>
          </div>
          <div className="w-px h-8 bg-gray-200"></div>
          <div>
            {user ? (
              <div className="relative py-2 z-[100]" onMouseEnter={() => setIsUserMenuOpen(true)} onMouseLeave={() => setIsUserMenuOpen(false)}>
                <div className="flex flex-col items-end cursor-pointer">
                  <span className="text-xs font-black text-[#0f766e] flex items-center gap-1.5 transition-colors hover:text-[#0a524c]">
                    Hi, {user.name.split(' ')[0]}
                    <svg className={`w-3 h-3 transition-transform ${isUserMenuOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M19 9l-7 7-7-7" /></svg>
                  </span>
                </div>
                <AnimatePresence>
                  {isUserMenuOpen && (
                    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} className="absolute right-0 top-full mt-0 w-44 bg-white shadow-xl rounded-lg border border-slate-100 overflow-hidden">
                      <Link to="/donor-profile" className="block px-5 py-3 text-[11px] font-bold text-slate-700 hover:bg-orange-50 hover:text-[#0f766e] uppercase tracking-wider border-b border-slate-50 transition-colors">My Profile</Link>
                      <Link to="/donor-profile?tab=history" className="block px-5 py-3 text-[11px] font-bold text-slate-700 hover:bg-orange-50 hover:text-[#0f766e] uppercase tracking-wider border-b border-slate-50 transition-colors">Donation History</Link>
                      <button onClick={handleLogout} className="w-full text-left px-5 py-3 text-[11px] font-bold text-red-500 hover:bg-red-50 uppercase tracking-wider transition-colors">Logout</button>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ) : (
              <button onClick={() => setIsAuthModalOpen(true)} className="bg-[#0f766e] text-white px-5 py-2 text-xs font-bold rounded-md uppercase tracking-wider hover:bg-slate-800 transition-all flex items-center gap-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg> Login
              </button>
            )}
          </div>
        </div>
      </div>
      
      <div className="lg:hidden flex justify-between items-center px-4 py-2">
        <Link to="/"><img src={logo} alt="Logo" className="h-14 w-auto object-contain" /></Link>
        <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-900 p-2">
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMobileMenuOpen ? <path d="M6 18L18 6M6 6l12 12" strokeWidth="2.5" strokeLinecap="round"/> : <path d="M4 6h16M4 12h16M4 18h16" strokeWidth="2.5" strokeLinecap="round"/>}
          </svg>
        </button>
      </div>

      <nav className="bg-[#0f766e] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="hidden lg:flex justify-between items-stretch h-14">
            <div className="flex items-center">
              <Link to="/" className={`px-6 py-4 text-xs font-black uppercase tracking-widest hover:bg-white/10 transition-all ${location.pathname === '/' ? 'bg-white/10' : ''}`}>Home</Link>
              {Object.keys(dropdownContent).map((menuName) => (
                <div key={menuName} className="relative h-full flex items-center" onMouseEnter={() => setActiveDropdown(menuName)} onMouseLeave={() => setActiveDropdown(null)}>
                  <button className="px-6 py-4 text-xs font-black uppercase tracking-widest transition-all hover:bg-white/10 flex items-center gap-1.5">
                    {menuName}
                    <svg className={`w-3 h-3 transition-transform ${activeDropdown === menuName ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </button>
                  <AnimatePresence>
                    {activeDropdown === menuName && (
                      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} className="absolute left-0 top-full w-72 bg-white text-gray-800 shadow-2xl rounded-b-[2rem] overflow-hidden border border-gray-100 py-4 z-[100]">
                        {dropdownContent[menuName].map((item) => (
                          <Link key={item.name} to={item.path} className="block px-8 py-3.5 text-[11px] font-bold uppercase tracking-wider hover:bg-orange-50 hover:text-orange-600 transition-all border-b border-gray-50 last:border-0">{item.name}</Link>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
              <Link to="/contact" className="px-6 py-4 text-xs font-black uppercase tracking-widest hover:bg-white/10 transition-all">Get In Touch</Link>
            </div>
            <button onClick={() => setIsModalOpen(true)} className="bg-[#ffb000] hover:bg-white hover:text-[#ffb000] text-gray-950 px-12 font-black text-xs tracking-[0.2em] transition-all h-full shadow-inner">DONATE</button>
          </div>
        </div>

        <AuthModal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} onLoginSuccess={(userData: any) => setUser(userData)} />

        <AnimatePresence>
          {isMobileMenuOpen && (
            <motion.div initial={{ opacity: 0, x: 300 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 300 }} className="lg:hidden fixed inset-0 bg-black/50 z-[200]">
              <div className="absolute right-0 top-0 bottom-0 w-80 bg-white shadow-2xl flex flex-col">
                <div className="p-6 flex justify-between items-start border-b border-gray-100 bg-slate-50">
                  {user ? (
                    <div className="flex flex-col w-full pr-4">
                      <span className="text-sm font-black text-[#0f766e] uppercase tracking-wider block border-b border-slate-200 pb-2 mb-2">Hi, {user.name}</span>
                      <div className="flex flex-col gap-1.5 mt-1">
                        <Link to="/donor-profile" onClick={() => setIsMobileMenuOpen(false)} className="text-[11px] font-bold text-slate-600 hover:text-[#0f766e] uppercase tracking-wider py-1.5 flex items-center gap-2"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg> My Profile</Link>
                        <Link to="/donor-profile?tab=history" onClick={() => setIsMobileMenuOpen(false)} className="text-[11px] font-bold text-slate-600 hover:text-[#0f766e] uppercase tracking-wider py-1.5 flex items-center gap-2"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg> Donation History</Link>
                        <button onClick={() => { handleLogout(); setIsMobileMenuOpen(false); }} className="text-[11px] font-bold text-red-500 hover:text-red-700 uppercase tracking-wider py-1.5 flex items-center gap-2 text-left mt-1"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg> Logout</button>
                      </div>
                    </div>
                  ) : (
                    <button onClick={() => { setIsAuthModalOpen(true); setIsMobileMenuOpen(false); }} className="bg-[#0f766e] text-white px-6 py-2.5 text-xs font-bold rounded-lg uppercase tracking-wider hover:bg-slate-800 transition-all flex items-center gap-2 shadow-sm mt-1"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg> Login / Register</button>
                  )}
                  <button onClick={() => setIsMobileMenuOpen(false)} className="text-gray-400 hover:text-gray-900 p-1 bg-white rounded shadow-sm border border-slate-200 shrink-0"><svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg></button>
                </div>
                <div className="flex-1 overflow-y-auto p-6 space-y-6">
                  {Object.keys(dropdownContent).map(menu => (
                    <div key={menu} className="space-y-3">
                      <div className="text-orange-600 font-black text-[10px] uppercase tracking-widest">{menu}</div>
                      <div className="flex flex-col gap-2 pl-4 border-l-2 border-slate-100">
                        {dropdownContent[menu].map(sub => (
                          <Link key={sub.name} to={sub.path} onClick={() => setIsMobileMenuOpen(false)} className="py-2 text-xs font-bold text-gray-700 hover:text-[#0f766e] uppercase tracking-wider">{sub.name}</Link>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="p-6 border-t border-gray-100 bg-white">
                  <button onClick={() => {setIsModalOpen(true); setIsMobileMenuOpen(false);}} className="w-full bg-[#ffb000] hover:bg-[#e6a000] text-gray-950 py-4 rounded-xl font-black text-xs tracking-widest uppercase shadow-md transition-all">DONATE NOW</button>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
      <DonationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
};

export default Navbar;